import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const SpeciesPage = lazy(() => import('../pages/species/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ArticlePage = lazy(() => import('../pages/blog/article/page'));
const AboutPage = lazy(() => import('../pages/sobre-nosotros/page'));
const ContactPage = lazy(() => import('../pages/contacto/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/perros',
    element: <SpeciesPage />,
  },
  {
    path: '/gatos',
    element: <SpeciesPage />,
  },
  {
    path: '/conejos',
    element: <SpeciesPage />,
  },
  {
    path: '/hurones',
    element: <SpeciesPage />,
  },
  {
    path: '/erizos',
    element: <SpeciesPage />,
  },
  {
    path: '/cobayos',
    element: <SpeciesPage />,
  },
  {
    path: '/chinchillas',
    element: <SpeciesPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <ArticlePage />,
  },
  {
    path: '/sobre-nosotros',
    element: <AboutPage />,
  },
  {
    path: '/contacto',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;